'use es6';

import { fromJS } from 'immutable';
import { mapperFunction } from './responseMapperUtils';
export default function responseMapper(response) {
  return fromJS(response, mapperFunction);
}